import type { SelectItemType } from '@/components/base/select/select';

import { jobTitlesControllerFindAll } from '@/api/core-api';

export async function searchJobTitles(
  query: string,
): Promise<SelectItemType[]> {
  const trimmed = query.trim().slice(0, 30);

  const params =
    trimmed.length >= 3
      ? { page: 1, pageSize: 25, query: trimmed }
      : { page: 1, pageSize: 25 };

  const res = await jobTitlesControllerFindAll({ query: params });

  return (res.data?.results ?? []).map((dto) => ({
    id: dto.id,
    label: dto.name,
  }));
}
